import { render, staticRenderFns } from "./CameraTtsButton.vue?vue&type=template&id=0938c41e"
import script from "./CameraTtsButton.vue?vue&type=script&lang=js"
export * from "./CameraTtsButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports